import { render, staticRenderFns } from "./EmailIntegration.vue?vue&type=template&id=319401e2&scoped=true"
import script from "./EmailIntegration.vue?vue&type=script&lang=js"
export * from "./EmailIntegration.vue?vue&type=script&lang=js"
import style0 from "./EmailIntegration.vue?vue&type=style&index=0&id=319401e2&prod&scoped=true&lang=scss"
import style1 from "./EmailIntegration.vue?vue&type=style&index=1&id=319401e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319401e2",
  null
  
)

export default component.exports